import videoStatus from "utils/videoStatusUtils";
import { CountModal } from "./Modal";
import { format } from "date-fns";

const imageStyle = { width: "23px", height: "28px" };

export const defaultColumns = [
  { field: "select", type: "select", maxWidth: "65px" },
  { field: "title", label: "Título", align: "left" },
  {
    field: "status",
    label: "Status",
    render: (value) => videoStatus?.[value] || "",
  },
  { field: "totalViews", label: "Visualizações" },
  {
    field: "personalitiesCredits",
    label: "Crédito (Personalidade)",
    render: (value, row) => (
      <CountModal
        title="Personalidades associadas"
        description={`O vídeo "${row.title}" está associado as seguintes personalidades (Crédito):`}
        listIcon={
          <img
            src="/img/navbar_cockpit/personalidade_icon.svg"
            alt="Personalidades Associadas"
            style={imageStyle}
          />
        }
        list={value}
      />
    ),
  },
  {
    field: "personalities",
    label: "Com Quem (Personalidade)",
    render: (value, row) => (
      <CountModal
        title="Personalidades associadas"
        description={`O vídeo "${row.title}" está associado as seguintes personalidades (Com Quem?):`}
        listIcon={
          <img
            src="/img/navbar_cockpit/personalidade_icon.svg"
            alt="Personalidades Associadas"
            style={imageStyle}
          />
        }
        list={value}
      />
    ),
  },
  {
    field: "keywords",
    label: "Palavras-Chave",
    render: (value, row) => (
      <CountModal
        title="Palavras-Chave associadas"
        description={`O vídeo "${row.title}" está associado as seguintes palavras-chave:`}
        listIcon={
          <img
            src="/img/navbar_cockpit/palavras_chave_icon.svg"
            alt="Palavras-chave Associadas"
            style={imageStyle}
          />
        }
        list={value?.map((v) => {
          v.name = (
            <div className="filtered_content_main">
              <div className="filtered_content_title">Palavra-Chave: </div>
              <div className="filtered_content_content">({v.value})</div>
            </div>
          );
          return v;
        })}
      />
    ),
  },
  {
    field: "collections",
    label: "Coleção",
    align: "left",
    render: (value, row) => (
      <CountModal
        title="Coleções associadas"
        description={`O vídeo "${row.title}" está associado as seguintes coleções:`}
        listIcon={
          <img
            src="/img/navbar_cockpit/colecoes_icon.svg"
            alt="Coleções Associadas"
            style={imageStyle}
          />
        }
        list={value}
      />
    ),
  },
  {
    field: "units",
    label: "Unidade",
    render: (value, row) => (
      <CountModal
        title="Unidades associadas"
        description={`O vídeo "${row.title}" está associado as seguintes unidades:`}
        listIcon={
          <img
            src="/img/navbar_cockpit/unidades_sesc_icon.svg"
            alt="Unidades Associadas"
            style={imageStyle}
          />
        }
        list={value}
      />
    ),
  },
  {
    field: "channels",
    label: "Canal",
    render: (value, row) => (
      <CountModal
        title="Canais associados"
        description={`O vídeo "${row.title}" está associado aos seguintes canais:`}
        listIcon={
          <img
            src="/img/navbar_cockpit/canais_sesc_icon.svg"
            alt="Canais Associados"
            style={imageStyle}
          />
        }
        list={value}
      />
    ),
  },
  {
    field: "createdBy",
    label: "Editor",
    render: (value) => value?.name || "-",
  },
  {
    field: "updatedAt",
    label: "Última atualização",
    render: (value) =>
      value ? format(new Date(value), "HH:mm dd/MM/yyyy") : "-",
  },
  { field: "viewsLimit", label: "Limite de Players" },
  {
    field: "expiresIn",
    label: "Data limite de veiculação",
    render: (value) =>
      value ? format(new Date(value), "HH:mm dd/MM/yyyy") : "-",
  },
];
